style= require('./claimed-matches.styl')
- var moment = require('moment')
- var amountMatches = 6
.claimed-matches
  if realMatches && realMatches.length >= 1
    .matches-container
      if realMatches.length >= amountMatches
        .left((click)=scrollMatches(e.target))
          ft-icon(name='ui--left')
        .right((click)=this.scrollMatches(e.target))
          ft-icon(name='ui--right')
    .matches-list
      each sport in uniqueSports
        .sport-container
          .sport
            ft-icon(name=`sports--${sport}`)
            .name= sport
          .sport-matches
            each match, index in filterSport(sport)
              a.match(
                data-match=match._id,
                class={active: match === this.match},
                href=this.url(match)
              )
                section
                  .status(class=match.status )
                  .status-text= moment(match.startTime).fromNow()
                  ft-toggle(
                    checked=matchClass(match) === 'owned',
                    (change)=this.claim(match, e))
                sporty-status(match=match, view-dashboard)
  .main
    if match && (match.sport === 'golf' || match.sport === 'rocket_runout' || (match.sport === 'eurovision' && match.matchType === 'qualifier'))
      sporty-golf-results(match=match)
    else if match && match.isTeamDuel
      sporty-duel-results(match=match)
    else if match && match.isIndividualDuel
      sporty-individual-duel-results(match=match)
    else if match && match.isTimeTrial
      sporty-time-trial-results(match=match)
    else if match && match.isRacing
      sporty-race-results(match=match)
    else if match && match.isDuel
      sporty-results(match=match)
